import { UPDATE_ACTIONS } from './updateActions';
import { MENTEE_LESSON_STATUSES } from 'data/menteeLessonStatuses';
import { SUPER_BATCH_TYPES } from 'data/superBatchTypes';

export const PAST_CLASSES_VISIBILITY_DATA = {
  [UPDATE_ACTIONS.add]: {
    [SUPER_BATCH_TYPES.secondary]: [
      {
        label: 'Add in Archived Section',
        value: MENTEE_LESSON_STATUSES.archived,
      },
      {
        label: 'Add in Active Section',
        value: MENTEE_LESSON_STATUSES.active,
      },
      {
        label: 'Do not Add',
        value: 'undefined',
      },
    ],
    [SUPER_BATCH_TYPES.crashCourse]: [
      {
        label: 'Add in Archived Section',
        value: MENTEE_LESSON_STATUSES.archived,
      },
      {
        label: 'Add in Additional Live Content',
        value: MENTEE_LESSON_STATUSES.crashCourse,
      },
      {
        label: 'Do not Add',
        value: 'undefined',
      },
    ],
  },
  [UPDATE_ACTIONS.remove]: {
    [SUPER_BATCH_TYPES.secondary]: [
      {
        label: 'Keep in Active Section',
        value: MENTEE_LESSON_STATUSES.active,
      },
      {
        label: 'Move to Archive Section',
        value: MENTEE_LESSON_STATUSES.archived,
      },
      {
        label: 'Delete all Past Classes',
        value: MENTEE_LESSON_STATUSES.inactive,
      },
    ],
    [SUPER_BATCH_TYPES.crashCourse]: [
      {
        label: 'Move to Archive Section',
        value: MENTEE_LESSON_STATUSES.archived,
      },
      {
        label: 'Keep In Additional Live Content',
        value: MENTEE_LESSON_STATUSES.crashCourse,
      },
      {
        label: 'Delete all Past Classes',
        value: MENTEE_LESSON_STATUSES.inactive,
      },
    ],
  },
};
